module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq458-28f0b3c61d1a3bd58f0becb67d1ad2e2.jpg";